module.exports = __webpack_public_path__ + "static/media/message.79f63138.svg";